// extracted by mini-css-extract-plugin
export default {"inheritColor":"inheritColor_XuKnI","opacityOnHover":"opacityOnHover_vTOcP","underline":"underline_ygCQ0","noUnderline":"noUnderline_ZT4Gx"};